/* Grey Chapel — gc-zoom.js
   PDP gallery image warming and zoom (hover on desktop, tap on touch). See docs/gc-zoom.md. */
(function () {
  'use strict';
  var GC = window.GC;
  if (!GC) return;

  /* The gallery hands its slides over once initProduct has built them.
     isScrolling() is read live, not snapshotted: the carousel sets it true
     for the duration of a swipe and hover-zoom must stay off while it is. */
  GC.on('gallery:ready', function (ctx) {
    var section = ctx.section, slides = ctx.slides, track = ctx.track;
    var isScrolling = ctx.isScrolling;

    /* Desktop hover magnifies in place; touch taps open a fullscreen viewer.
       Gated by the section's data-zoom attribute (max level). */
    var zoomMax = parseFloat(section.getAttribute('data-zoom')) || 0;

    /* #c77k1 A slide counts as shown once a rendition of real size has decoded. */
    var decodedReal = function (img) { return img.complete && img.naturalWidth >= 200; };

    /* #h9qos Read the way the browser reads it: first matching <source>, else the img's own
       srcset. On mobile the phone's candidates live on a media-scoped <source> and
       the img srcset is the desktop ladder — magnifying from that pulls a
       desktop-sized file down a phone connection. */
    var widestCandidate = function (img) {
      var set = '';
      var pic = img.parentNode;
      if (pic && pic.tagName === 'PICTURE') {
        var sources = pic.querySelectorAll('source[srcset]');
        for (var i = 0; i < sources.length; i++) {
          var media = sources[i].getAttribute('media');
          if (!media || window.matchMedia(media).matches) { set = sources[i].getAttribute('srcset'); break; }
        }
      }
      if (!set) set = img.getAttribute('srcset') || '';
      var best = '', bestW = 0;
      set.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        if (!bits[0]) return;
        var w = parseInt(bits[1], 10) || 0;
        if (w >= bestW) { bestW = w; best = bits[0]; }
      });
      return best;
    };

    /* Scale from the width the browser actually chose, not a hardcoded base: the
       gallery rendition varies with the resolution caps in theme settings. Scaling
       the placeholder is what stuck the viewer on a thumbnail-of-a-thumbnail. */
    var hiResSrc = function (img) {
      var src = (decodedReal(img) ? '' : widestCandidate(img)) || img.currentSrc || img.src;
      var m = src.match(/[?&]width=(\d+)/);
      var base = m ? parseInt(m[1], 10) : 1100;
      /* Shopify's CDN refuses widths over 5760 — a high desktop cap times a high
         zoom level can clear that on its own. */
      var want = Math.min(Math.round(base * zoomMax), 5760);
      return src.replace(/([?&])width=\d+/, '$1width=' + want);
    };

    /* #q9cwq Warms gallery images after load so swiping and zooming don't wait on the network.
       How much depends on the link — the old version cost several MB on cellular.
       Safari/iOS has no navigator.connection, so an unknown connection is metered. */
    if (slides.length) {
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var fastLink = !!conn && (conn.effectiveType === '4g' || conn.effectiveType === '5g');
      var roomy = window.matchMedia('(min-width: 990px) and (pointer: fine)').matches;
      var generous = roomy || fastLink;

      var warmGallery = function () {
        if (conn && conn.saveData) return;               /* Data Saver: warm nothing. */
        var seenColor = {};
        slides.forEach(function (slide, i) {
          var img = slide.querySelector('img');
          if (!img) return;
          if (!generous) {
            /* Metered: one slide per colour, so a colour tap lands on something at once.
               Duplicate mockups of a colour load when they are actually swiped to. */
            var color = slide.getAttribute('data-color') || ('#' + i);
            if (seenColor[color]) return;
            seenColor[color] = true;
          }
          /* Promote the element, not `new Image().src`, so the browser resolves the
             <picture> normally — otherwise a phone warms the desktop fallback. */
          if (img.loading === 'lazy') img.loading = 'eager';
          if (generous && zoomMax > 1) new Image().src = hiResSrc(img);
        });
      };
      /* The rest wait on the first mockup, not window 'load', which also waits out
         webfonts and review widgets — often a second of idle connection after the
         image they can see has arrived. 'load' stays as a backstop. */
      var warmed = false;
      var startWarm = function () {
        if (warmed) return;
        warmed = true;
        setTimeout(warmGallery, 200);
      };
      var firstImg = slides[0] && slides[0].querySelector('img');
      if (firstImg) {
        var onFirstLoad = function () {
          /* A progressive slide fires 'load' for its placeholder too; that is not
             the mockup being waited on. */
          if (firstImg.complete && firstImg.naturalWidth < 200) return;
          firstImg.removeEventListener('load', onFirstLoad);
          startWarm();
        };
        if (firstImg.complete && firstImg.naturalWidth >= 200) startWarm();
        else {
          firstImg.addEventListener('load', onFirstLoad);
          firstImg.addEventListener('error', startWarm, { once: true });
        }
      }
      if (document.readyState === 'complete') startWarm();
      else window.addEventListener('load', startWarm);
    }

    if (track && zoomMax > 1) {
      /* #7wjoo A swappable pair, not picked once at load: a tablet losing its keyboard, a
         window dragged to phone width and DevTools emulation all flip this query,
         and the other mode's handlers must come off cleanly. */
      var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
      var zoomHintText = section.getAttribute('data-zoom-hint') || '';
      var zoomTeardown = [];
      var zbox = null, zpane, zfig, zimg, zoomToken = 0, zoomAspect = 0;

      /* Sized from the aspect ratio alone, never the rendition's pixel width. That is
         what holds the low-res and full-res versions at one displayed size, and
         stops a portrait shot opening pre-zoomed. */
      var fitZoomFigure = function () {
        if (!zfig || !zpane) return;
        var pw = zpane.clientWidth;
        var ph = zpane.clientHeight - (zoomHintText ? 40 : 0);
        var w = zoomAspect > 0 ? Math.min(pw, Math.max(ph, 1) * zoomAspect) : pw;
        zfig.style.width = Math.round(w) + 'px';
      };

      var closeZoombox = function () {
        if (!zbox) return;
        zbox.classList.remove('is-open', 'is-magnified', 'is-loading', 'is-handoff');
        /* invalidates any rendition still in flight for the slide just closed */
        zoomToken++;
        document.body.style.overflow = '';
        zoomLayer.close();
      };
      var zoomLayer = GC.backLayer(closeZoombox);

      /* #h709l Open on the already-decoded gallery rendition — soft but instant, where an
         empty viewer reads as broken — then swap in the sharp one. It is preloaded
         into cache first, so the swap cannot flash; no fade is wanted. */
      var showZoomImage = function (img) {
        var token = ++zoomToken;
        var ready = decodedReal(img);
        var placeholder = img.currentSrc || img.src;
        /* Requested at full size on the tap itself, so opening on a still-loading slide
           no longer depends on that slide ever finishing. */
        var full = hiResSrc(img);
        /* naturalWidth is 0 on a slide that has not decoded yet; the width/height
           attributes from snippets/img.liquid always carry the true ratio. */
        var nw = img.naturalWidth || parseFloat(img.getAttribute('width')) || 0;
        var nh = img.naturalHeight || parseFloat(img.getAttribute('height')) || 0;
        zoomAspect = (nw > 0 && nh > 0) ? (nw / nh) : 0;
        fitZoomFigure();
        /* #y7c2q The viewer's <img> is shared, and a new src keeps painting the old picture until it decodes, so a green slide opened after a black one showed black. Empty it unless this slide is already decoded. */
        if (ready) zimg.src = placeholder; else zimg.removeAttribute('src');

        /* #ek6vu Carry a tile handoff in as the viewer's stand-in; without one the CSS falls back
           to the candlelight glow. The ratio has to come with it: an undecoded image has no
           intrinsic size, so height:auto resolves to zero and the background gets no box
           to paint in. The width/height attributes from snippets/img.liquid always carry
           the true ratio, which is what zoomAspect already holds. */
        var slidePh = img.style ? img.style.getPropertyValue('--gc-ph') : '';
        var slideHandoff = img.classList.contains('gc-handoff');
        /* No handoff: stand in with this slide's own thumbnail when it has loaded, so the colour is right from the first frame. */
        if (!slidePh) {
          var slideEl = img.closest('[data-slide]');
          var mid = slideEl && slideEl.getAttribute('data-media-id');
          var th = mid && section.querySelector('[data-thumb][data-media-id="' + mid + '"] img');
          if (th && th.complete && th.naturalWidth > 0) slidePh = 'url("' + (th.currentSrc || th.src) + '")';
        }
        var holdPlaceholder = function (on) {
          if (on && slidePh) zimg.style.setProperty('--gc-ph', slidePh);
          else zimg.style.removeProperty('--gc-ph');
          zimg.style.aspectRatio = (on && zoomAspect > 0) ? String(zoomAspect) : '';
          zbox.classList.toggle('is-handoff', !!(on && slidePh && slideHandoff));
        };
        holdPlaceholder(!ready);

        /* Opened before the slide decoded: the stand-in shows until a real rendition is in. */
        zbox.classList.toggle('is-loading', !ready);
        var settle = function () {
          if (token !== zoomToken) return;
          zbox.classList.remove('is-loading');
          /* A real rendition brings its own size, and a transparent PNG would otherwise
             go on compositing the thumbnail underneath itself. */
          holdPlaceholder(false);
        };
        if (full === placeholder) { settle(); return; }
        var hi = new Image();
        hi.onload = function () {
          if (token !== zoomToken) return;   /* another slide was opened meanwhile */
          zimg.src = full;
          settle();
        };
        hi.onerror = settle;
        hi.src = full;

        /* Take the gallery's own rendition the moment it decodes — free, that fetch was
           already running. Not gated on the magnified state: swapping the source
           keeps the figure's width, so an upgrade lands either way. */
        if (!ready) {
          /* Not one-shot: the slide's placeholder fires load too, and consuming the
             listener on it would leave a thumbnail up for the sharp rendition. */
          var onSlideLoad = function () {
            if (token !== zoomToken || !zbox.classList.contains('is-open')) {
              img.removeEventListener('load', onSlideLoad);
              return;
            }
            if (!decodedReal(img)) return;                        /* still the placeholder */
            img.removeEventListener('load', onSlideLoad);
            if (!zbox.classList.contains('is-loading')) return;   /* sharp one already in */
            zimg.src = img.currentSrc || img.src;
            holdPlaceholder(false);
            zoomAspect = img.naturalWidth / img.naturalHeight;
            if (!zbox.classList.contains('is-magnified')) fitZoomFigure();
          };
          img.addEventListener('load', onSlideLoad);
        }
      };

      var buildZoombox = function () {
        zbox = document.createElement('div');
        zbox.className = 'gc-zoombox';
        zbox.innerHTML =
          '<button type="button" class="gc-zoombox__close" aria-label="Close">×</button>' +
          '<div class="gc-zoombox__pane"><div class="gc-zoombox__fig"><img alt="">' +
          (zoomHintText ? '<p class="gc-zoombox__hint"></p>' : '') +
          '</div></div>';
        document.body.appendChild(zbox);
        zpane = zbox.querySelector('.gc-zoombox__pane');
        zfig = zbox.querySelector('.gc-zoombox__fig');
        zimg = zbox.querySelector('img');
        var hintEl = zbox.querySelector('.gc-zoombox__hint');
        if (hintEl) hintEl.textContent = zoomHintText;
        /* #m2g8v A mouse drags the magnified picture around; a press that moved is a pan, not a click. */
        zimg.setAttribute('draggable', 'false');
        var drag = null, dragged = false;
        zpane.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0 || !zbox.classList.contains('is-magnified')) return;
          drag = { x: e.clientX, y: e.clientY, l: zpane.scrollLeft, t: zpane.scrollTop };
          dragged = false;
          zbox.classList.add('is-grabbing');
          e.preventDefault();
        });
        window.addEventListener('pointermove', function (e) {
          if (!drag) return;
          var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
          if (Math.abs(dx) + Math.abs(dy) > 4) dragged = true;
          zpane.scrollLeft = drag.l - dx;
          zpane.scrollTop = drag.t - dy;
        });
        window.addEventListener('pointerup', function () {
          if (!drag) return;
          drag = null;
          zbox.classList.remove('is-grabbing');
        });
        zbox.addEventListener('click', function (e) {
          if (dragged) { dragged = false; return; }
          if (e.target === zimg) {
            /* The figure always carries an explicit width, so the class — not the
               presence of a style — is what says whether we are magnified. */
            if (zbox.classList.contains('is-magnified')) {
              zbox.classList.remove('is-magnified');
              fitZoomFigure();
            } else {
              var fx = e.offsetX / zimg.clientWidth, fy = e.offsetY / zimg.clientHeight;
              /* #u6r1p Magnify from the picture's fitted size, not the pane: on desktop the fitted picture is height-bound, so pane width × 2.5 was about five times the picture. */
              var w = zfig.offsetWidth * zoomMax;
              zfig.style.width = w + 'px';
              zpane.scrollLeft = fx * w - zpane.clientWidth / 2;
              zpane.scrollTop = fy * zimg.clientHeight - zpane.clientHeight / 2;
              /* the hint has served its purpose once they're in */
              zbox.classList.add('is-magnified');
            }
            return;
          }
          closeZoombox();
        });
        window.addEventListener('resize', function () {
          if (zbox.classList.contains('is-open') && !zbox.classList.contains('is-magnified')) fitZoomFigure();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && zbox.classList.contains('is-open')) closeZoombox();
        });
      };

      var enableHoverZoom = function () {
        slides.forEach(function (slide) {
          var img = slide.querySelector('img');
          if (!img) return;
          slide.classList.add('gc-zoomable');

          /* Only once a real rendition has decoded. A progressive slide's `src` is never
             rewritten — only `srcset` — so both src and currentSrc report the 32px
             placeholder until the chosen candidate lands. Scaling that gave an ~80px
             background, cached on the slide for the life of the page. */
          var primeHiRes = function () {
            if (slide.gcHiSrc || slide.gcHiPending || slide.gcHiFailed) return;
            if (!img.complete || img.naturalWidth < 200) return;
            slide.gcHiPending = true;
            var gen = slide.gcHiGen || 0;
            var hiUrl = hiResSrc(img);
            var hi = new Image();
            hi.onload = function () {
              if (gen !== (slide.gcHiGen || 0)) return;   /* rendition changed under us */
              slide.gcHiSrc = hiUrl;
              slide.gcHiPending = false;
              if (slide.classList.contains('is-zooming')) {
                slide.style.backgroundImage = 'url("' + hiUrl + '")';
              }
            };
            /* gcHiFailed stops a retry firing on every subsequent mousemove —
               primeHiRes now runs on each one, not just on hover entry */
            hi.onerror = function () {
              if (gen !== (slide.gcHiGen || 0)) return;
              slide.gcHiPending = false;
              slide.gcHiFailed = true;
            };
            hi.src = hiUrl;
          };

          /* The rendition changed — progressive promotion or a breakpoint swap — so
             everything derived from the old one is stale, magnified layer included. */
          var onImgLoad = function () {
            slide.gcHiGen = (slide.gcHiGen || 0) + 1;
            slide.gcHiSrc = null;
            slide.gcHiPending = false;
            slide.gcHiFailed = false;
            if (slide.classList.contains('is-zooming')) {
              slide.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
            }
            primeHiRes();
          };

          var onMove = function (e) {
            if (isScrolling()) return;
            var rect = slide.getBoundingClientRect();
            var pos =
              ((e.clientX - rect.left) / rect.width) * 100 + '% ' +
              ((e.clientY - rect.top) / rect.height) * 100 + '%';
            if (!slide.classList.contains('is-zooming')) {
              /* The zoomed layer sits at full magnification behind the image, which
                 fades out to reveal it. No scale motion. */
              clearTimeout(slide.gcBgTimer);
              /* As in the fullscreen viewer: magnify the decoded rendition so the layer
                 is never blank behind the fading image, then upgrade. */
              slide.style.backgroundImage = 'url("' + (slide.gcHiSrc || img.currentSrc || img.src) + '")';
              slide.style.backgroundSize = (zoomMax * 100) + '%';
              slide.classList.add('is-zooming');
            }
            primeHiRes();
            slide.style.backgroundPosition = pos;
          };
          var onLeave = function () {
            slide.classList.remove('is-zooming');
            clearTimeout(slide.gcBgTimer);
            slide.gcBgTimer = setTimeout(function () {
              slide.style.backgroundImage = '';
              slide.style.backgroundSize = '';
            }, 200);
          };
          slide.addEventListener('mousemove', onMove);
          slide.addEventListener('mouseleave', onLeave);
          img.addEventListener('load', onImgLoad);
          zoomTeardown.push(function () {
            slide.removeEventListener('mousemove', onMove);
            slide.removeEventListener('mouseleave', onLeave);
            img.removeEventListener('load', onImgLoad);
            clearTimeout(slide.gcBgTimer);
            slide.gcHiGen = (slide.gcHiGen || 0) + 1;
            slide.gcHiFailed = false;
            slide.classList.remove('gc-zoomable', 'is-zooming');
            slide.style.backgroundImage = '';
            slide.style.backgroundSize = '';
            /* the cached hi-res was derived from the rendition in force before
               the breakpoint moved, so it is the wrong size now */
            slide.gcHiSrc = null;
          });
        });
      };

      var enableTapZoom = function () {
        slides.forEach(function (slide) {
          var img = slide.querySelector('img');
          if (!img) return;
          var onTap = function () {
            if (!zbox) buildZoombox();
            /* Open first: the box is display:none until is-open, so measuring the
               pane before this point returns zero and the fit collapses. */
            zbox.classList.add('is-open');
            zbox.classList.remove('is-magnified');
            document.body.style.overflow = 'hidden';
            zoomLayer.open();
            showZoomImage(img);
            zpane.scrollTop = 0; zpane.scrollLeft = 0;
          };
          slide.addEventListener('click', onTap);
          zoomTeardown.push(function () { slide.removeEventListener('click', onTap); });
        });
      };

      var applyZoomMode = function () {
        zoomTeardown.forEach(function (fn) { fn(); });
        zoomTeardown = [];
        closeZoombox();
        /* Desktop keeps hover magnify; the section's "click opens the viewer" setting adds the click on top of it. */
        if (hoverQuery.matches) {
          enableHoverZoom();
          if (section.hasAttribute('data-zoom-click')) enableTapZoom();
        } else enableTapZoom();
      };
      applyZoomMode();
      if (hoverQuery.addEventListener) hoverQuery.addEventListener('change', applyZoomMode);
      else if (hoverQuery.addListener) hoverQuery.addListener(applyZoomMode);
    }
  });
})();
